import { Injectable } from '@angular/core';

import { MediaQueryService } from '@frontend/vanilla/core';
import { BehaviorSubject } from 'rxjs';

// import {  BreakpointState } from '@angular/cdk/layout';
/**
 * @whatItDoes Provides utility functions for injecting third-party-scripts.
 *
 * @description
 * # Overview
 * Used to inject third party scripts into our application. Call the inject() method with the key and wait for it to resolve before calling the script functionality.
 * The corresponding Dynacon configuration can be found under the name MobilePortal.CommonFeatures.ScriptsInjectionData.
 * The corresponding Scripts need to be placed within the scripts folder of our application.
 * @stable
 */
@Injectable({
    providedIn: 'root',
})
export class PortalMediaQueryService {
    queryData: any;
    public mediaQuery = new BehaviorSubject('');
    constructor(private mediaQueryService: MediaQueryService) {
        this.mediaQueryService.observe().subscribe((data: any) => {
            this.mediaQuery.next(data);
        });
    }
}
